import { Link } from 'react-router-dom'
import './v2.css'

/* Hosts the admin surfaces inside the v2 cockpit shell so they wear the
 * cockpit chrome (navy sidebar, cool palette, Space Grotesk) instead of the
 * old v1 AppLayout. The pages already use the brand palette, so this alone
 * gets them most of the way to "the ops look"; per-page native polish is a
 * fast-follow. Role gating lives on the routes (App.tsx). */
export function AdminFrame({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <main className="detail">
      <div className="dhead">
        <h1>{title}</h1>
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: '20px 26px', minHeight: 0 }}>
        {children}
      </div>
    </main>
  )
}

interface AdminCard {
  to: string
  label: string
  blurb: string
}

const ADMIN_CARDS: AdminCard[] = [
  {
    to: '/v2/admin/policy',
    label: 'Policy',
    blurb: 'Evidence requirements, staleness periods, conflict rules.',
  },
  {
    to: '/v2/admin/users',
    label: 'Users',
    blurb: 'Officer & manager accounts and fund assignments.',
  },
  {
    to: '/v2/admin/logins',
    label: 'Logins',
    blurb: 'Who signed in, from where, and the live sessions.',
  },
  {
    to: '/v2/admin/health',
    label: 'System health',
    blurb: 'Pipeline, worker and database status.',
  },
  {
    to: '/v2/admin/eqs',
    label: 'Extraction quality',
    blurb: 'Aliases, filter rules, few-shots and golden tests.',
  },
  {
    to: '/v2/admin/prompt-ops',
    label: 'Prompt optimization',
    blurb: 'Prompt registry, eval volume, stage attribution and MIPRO runs.',
  },
]

/* Admin landing — the v2 home for the admin section. */
export default function AdminHome() {
  return (
    <main className="detail">
      <div className="dhead">
        <h1>Admin</h1>
      </div>
      <div
        className="dbody"
        style={{ flexDirection: 'column', gap: 12, padding: 22, alignContent: 'start' }}
      >
        {ADMIN_CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="vcard"
            style={{
              textDecoration: 'none',
              color: 'inherit',
              padding: '16px 20px',
              display: 'block',
            }}
          >
            <div style={{ fontSize: 'var(--text-16)', fontWeight: 700 }}>{c.label}</div>
            <div style={{ fontSize: 'var(--text-12)', color: 'var(--muted)', marginTop: 4 }}>
              {c.blurb}
            </div>
          </Link>
        ))}
      </div>
    </main>
  )
}
